import { CreativeType } from 'components/common/types';
import { CreativeStatus } from 'components/common/types/Creative.types';
import { Color } from 'lib/Chip';

export interface CreativeStatusBadge {
  code: string;
  name: string;
  initials: string;
  color: Color;
}

export const CREATIVE_STATUS_BADGE: CreativeStatusBadge[] = [
  {
    code: CreativeStatus.APPROVED,
    name: 'Approved',
    initials: 'A',
    color: Color.GREEN,
  },
  {
    code: CreativeStatus.REJECTED,
    name: 'Rejected',
    initials: 'R',
    color: Color.PINK_RED,
  },
  {
    code: CreativeStatus.PENDING,
    name: 'Pending',
    initials: 'PA',
    color: Color.YELLOW,
  },
  {
    code: CreativeStatus.SENT_FOR_APPROVAL,
    name: 'Sent for approval',
    initials: 'SFA',
    color: Color.YELLOW,
  },
  {
    code: CreativeStatus.FLAGGED,
    name: 'Flagged',
    initials: 'F',
    color: Color.YELLOW,
  },
  {
    code: CreativeStatus.UPLOADED,
    name: 'Uploaded',
    initials: 'U',
    color: Color.PRIMARY,
  },
  {
    code: CreativeStatus.DELETED,
    name: 'Deleted',
    initials: 'D',
    color: Color.PINK_RED,
  },
  {
    code: CreativeStatus.RESTORED,
    name: 'Restored',
    initials: 'R',
    color: Color.GREEN,
  },
];

export const REJECTED_TYPE = {
  AUTO: 'REJECTED_AUTO',
  MANUAL: 'REJECTED_MANUAL',
};

export const REJECTION_STATUS_BADGE: CreativeStatusBadge[] = [
  {
    code: REJECTED_TYPE.AUTO,
    name: 'Rejected (auto)',
    initials: 'R',
    color: Color.PINK_RED,
  },
  {
    code: REJECTED_TYPE.MANUAL,
    name: 'Rejected',
    initials: 'R',
    color: Color.PINK_RED,
  },
];

export const REJECTION_FILTER_OPTIONS = [
  { code: REJECTED_TYPE.AUTO, name: 'Rejected (auto)' },
  { code: REJECTED_TYPE.MANUAL, name: 'Rejected (manual)' },
];

export interface CreativeTypeOption {
  code: CreativeType.VIDEO | CreativeType.BANNER;
  name: string;
}

export const CREATIVE_TYPE_OPTIONS: CreativeTypeOption[] = [
  { code: CreativeType.VIDEO, name: 'Motion' },
  { code: CreativeType.BANNER, name: 'Still' },
];
